(()=>{
 const fill=async row=>{
  if(row.dataset.stockReady)return;row.dataset.stockReady='true';
  const cards=()=>Array.from(row.children).filter(el=>el.classList.contains('columns'));
  if(cards().length>=4)return;
  const productLinks=new Set(Array.from(row.querySelectorAll('a[href*="/products/"]')).map(a=>new URL(a.href).pathname.split('/products/')[1]));
  let url=row.dataset.topupUrl;
  while(url&&cards().length<4&&row.isConnected){
   try{
    const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)break;
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    for(const template of doc.querySelectorAll('template[data-stock-product]')){
     const link=template.content.querySelector('a[href*="/products/"]');if(!link)continue;
     const handle=new URL(link.getAttribute('href'),location.origin).pathname.split('/products/')[1];
     if(productLinks.has(handle))continue;
     row.append(template.content.cloneNode(true));productLinks.add(handle);
     if(cards().length>=4)break;
    }
    const next=doc.querySelector('[data-stock-next]');
    if(next){const parsed=new URL(next.getAttribute('href'),location.origin);parsed.searchParams.set('view','rl-stock-shelf');url=parsed.href;}else url=null;
   }catch{break;}
  }
 };
 const init=()=>document.querySelectorAll('[data-stock-shelf]').forEach(fill);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
